import { render, staticRenderFns } from "./SalesOrdersDetailProvider.vue?vue&type=template&id=27ae542f&"
import script from "./SalesOrdersDetailProvider.vue?vue&type=script&lang=js&"
export * from "./SalesOrdersDetailProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports